import { OccupationCategoriesCard } from "./OccupationCategoriesCard";
import { OccupationCategoriesUIProvider } from "./OccupationCategoriesUIContext";

export function OccupationCategoriesPage({ history }) {
  const categoriesUIEvents = {
    openNewCategoryPage: () => {
      history.push("/meslek-kategorileri/ekle");
    },
    openEditCategoryPage: (id) => {
      history.push(`/meslek-kategorileri/duzenle/${id}`);
    },
  };
  
  return (
    <OccupationCategoriesUIProvider categoriesUIEvents={categoriesUIEvents}>
      <OccupationCategoriesCard />
    </OccupationCategoriesUIProvider>
 );
}